<template>
    <div>
        <SubStepHeader
            v-if='hasSubHeader'
            :title="forms.title"
            :selectedValue="mentionText"
            :contentHidden="mentionHidden"
            @toggle-content="toggleMention"
        />
        <h3 
            v-if='!hasSubHeader' 
            class="green-text text-darken-1"
        >
            {{ forms.title }}
        </h3>
        <v-expand-transition>
            <div v-if="!mentionHidden || !hasSubHeader">
                <div>
                    <span class="habiteo-body-2 grey-text">
                        {{ forms.description }}
                    </span>
                </div>
                <StepBtnGroup
                    class="mt-4 step-group options"
                    :fields="fields"
                    :selectedValue="selectedOption"
                    :orientation="'row'"
                    layout="'card'"
                    @select-value="selectOption"
                />
                <DisclaimerPanel
                    v-show="isMentionActive"
                    @set-color="pickColor"
                    @set-text="setDisclaimerText"
                    @set-fontsize="setFontsize"
                    :selectedValues="{
                        'text': disclaimerText,
                        'color': disclaimerColor,
                        'fontsize': disclaimerFontsize
                    }"
                />
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import StepHeader from '@/components/myHabiteoStudio/steps/components/StepHeader';
    import StepBtnGroup from '@/components/myHabiteoStudio/steps/components/StepBtnGroup';
    import DisclaimerPanel from '@/components/myHabiteoStudio/steps/components/DisclaimerPanel';
    import SubStepHeader from '@/components/myHabiteoStudio/steps/components/SubStepHeader';

    export default {
        name: 'StepOptions',
        components: {
            DisclaimerPanel,
            StepHeader,
            StepBtnGroup,
            SubStepHeader
        },
        props: {
            subtitle: {
                type: String,
                required: true
            },
            forms: {
                type: Object,
                required: true
            },
            selectedOption: {
                type: Boolean,
                required: false
            },
            hasSubHeader: {
                type: Boolean,
                required: false
            }
        },
        data () {
            return {
                mentionHidden: true,
                storageKey: 'myHabiteo-studio-step-mention'
            }
        },
        mounted() {
            const storageValue = this.isLocalstorageAvailable ? JSON.parse(localStorage.getItem(this.storageKey)): null;
            const defaultValue = this.$props.forms.inputs[0].value !== null ? this.$props.forms.inputs[0].value : storageValue || this.$props.forms.inputs[0].fields[1].value ;
            this.selectOption(defaultValue);
        },
        computed: {
            ...mapGetters([
                'isLocalstorageAvailable'
            ]),
            fields() {
                return this.$props.forms.inputs[0].fields;
            },
            isMentionActive() {
                return this.$props.forms.inputs[0].value; 
            },
            disclaimerColor() {
                return this.$props.forms.inputs[0].color ? this.$props.forms.inputs[0].color : null;
            },
            disclaimerFontsize() {
                return this.$props.forms.inputs[0].fontsize ? this.$props.forms.inputs[0].fontsize : null;
            },
            disclaimerText() {
                return this.$props.forms.inputs[0].text ? this.$props.forms.inputs[0].text : null;
            },
            disclaimerUserSettings() {
                return this.isLocalstorageAvailable ? (localStorage.getItem('myHabiteo-studio-step-disclaimer') ? JSON.parse(localStorage.getItem('myHabiteo-studio-step-disclaimer')) : null) : null;
            },
            getSelectedOption() {
                return this.$props.forms.inputs[0] ? this.$props.forms.inputs[0].value : null;
            },
            mentionText() {
                const selectedMention = this.getSelectedOption ? this.fields.find(el => el.value === this.selectedOption) : null;
                return  selectedMention ? !selectedMention.value ? " : " + this.$t('habiteoStudio.noMention')  :" : " + this.$props.forms.inputs[0].text : " : " + this.$t('habiteoStudio.noMention');
            },
        },
        created() {
            // Default form values
            if (this.disclaimerUserSettings && this.$props.forms.inputs[0].text === undefined) {
                this.$props.forms.inputs[0].text = this.disclaimerUserSettings.text;
                this.$props.forms.inputs[0].color = this.disclaimerUserSettings.color;
                this.$props.forms.inputs[0].fontsize = this.disclaimerUserSettings.fontsize;
            } else {
                this.$props.forms.inputs[0].text = this.$props.forms.inputs[0].text || this.$t('habiteoStudio.templateDisclaimer');
                this.$props.forms.inputs[0].color = this.$props.forms.inputs[0].color || '#000000';
                this.$props.forms.inputs[0].fontsize = this.$props.forms.inputs[0].fontsize || 12;
            }
        },
        methods: {
            selectOption(option) {
                this.$props.forms.inputs[0].value = option;
            },
            pickColor(color) {
                this.$props.forms.inputs[0].color = color;
                this.$emit('update-disclaimer');
            },
            setDisclaimerText(text) {
                this.$props.forms.inputs[0].text = text;
                this.$emit('update-disclaimer');
            },
            setFontsize(fontsize) {
                this.$props.forms.inputs[0].fontsize = fontsize;
                this.$emit('update-disclaimer');
            },
            toggleMention() {
                this.mentionHidden = !this.mentionHidden;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/StepOptions.vue